import { render, staticRenderFns } from "./PatientTagInput.vue?vue&type=template&id=93d7de7e&scoped=true"
import script from "./PatientTagInput.vue?vue&type=script&lang=js"
export * from "./PatientTagInput.vue?vue&type=script&lang=js"
import style0 from "./PatientTagInput.vue?vue&type=style&index=0&id=93d7de7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "93d7de7e",
  null
  
)

export default component.exports